import React from 'react';
import './animations.css';
import { useInView } from 'react-intersection-observer';
import ocohstech_background from "../Assets/ocohstech_background.webp";

const pillars = [
    {
        title: "Our goal",
        body: "To provide an enriching learning environment that nurtures academic excellence and personal growth, equipping students with the skills and knowledge to succeed in an ever-changing world.",
    },
    {
        title: "Our mission",
        body: "To foster a dynamic and supportive learning community where students are inspired to achieve their full potential — cultivating critical thinking, creativity, and lifelong learning in every student.",
    },
    {
        title: "Our vision",
        body: "To be a leading institution recognized for educational excellence and innovation, empowering students with the knowledge and skills necessary to thrive in an ever-changing world.",
    },
];

const Sectwo = () => {

    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <div className="w-full bg-[#F6F5F1] pt-4 pb-24 px-4 md:px-10 lg:px-16">
            <div className="flex flex-col md:flex-row items-start gap-12 md:gap-16">

                <div className="w-full md:w-[52%]">
                    <div
                        ref={ref}
                        className={`flex items-center gap-2 mb-6 transition-opacity duration-1000 ease-in-out ${inView ? 'slide-in-from-left' : 'opacity-0'}`}
                    >
                        <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                        <span className="text-[#B8862E] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                            About us
                        </span>
                    </div>

                    <h2
                        className="text-3xl md:text-4xl text-[#12213D] leading-tight mb-6"
                        style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                    >
                        We're Experts Learning Institution
                    </h2>

                    <p
                        className="text-[#5B6472] text-base md:text-lg leading-relaxed mb-12 max-w-lg"
                        style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                        Dedicated to delivering top-tier education and fostering lifelong learning, we bring together rigorous academics and hands-on craft under one roof.
                    </p>

                    <div className="border-t border-[#12213D]/10 divide-y divide-[#12213D]/10">
                        {pillars.map((pillar) => (
                            <div key={pillar.title} className="py-8">
                                <h3
                                    className="text-xl text-[#12213D] mb-2"
                                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                                >
                                    {pillar.title}
                                </h3>
                                <p
                                    className="text-[#5B6472] leading-relaxed max-w-lg"
                                    style={{ fontFamily: "'Inter', sans-serif" }}
                                >
                                    {pillar.body}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="w-full md:w-[45%]">
                    <img
                        src={ocohstech_background}
                        alt="Campus at Experts Learning Institution"
                        className="w-full h-[360px] md:h-[720px] object-cover rounded-sm border border-[#12213D]/10"
                    />
                </div>
            </div>
        </div>
    )
}

export default Sectwo;